import { BACKGROUND_COLOR_PREFIX, TEXT_COLOR_PREFIX } from './plugins/textColor/textColorConstants';
import { EDITOR_SELECTORS } from './editorConstants';

export const isColorStyle = (style: string) => style.startsWith(TEXT_COLOR_PREFIX);
export const isBackgroundStyle = (style: string) => style.startsWith(BACKGROUND_COLOR_PREFIX);

export const isElementInEditor = (el: HTMLElement) => !!el.closest(EDITOR_SELECTORS.join(', '));
